import { render, staticRenderFns } from "./PublicMessage.vue?vue&type=template&id=0ce643b8&scoped=true"
import script from "./PublicMessage.vue?vue&type=script&lang=js"
export * from "./PublicMessage.vue?vue&type=script&lang=js"
import style0 from "./PublicMessage.vue?vue&type=style&index=0&id=0ce643b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce643b8",
  null
  
)

export default component.exports